import styled from "styled-components";
import { gray300, gray900 } from "core/resources/theme/colors";
import { RdoPeriodoSectionVm } from "./rdoOperacoes.types";
import { getRdoOcupacaoIconVisual } from "./getRdoOcupacaoIcon";
import RdoOperacoesTable from "./RdoOperacoesTable";

type Props = {
  section: RdoPeriodoSectionVm;
  filtersKey: string;
  expandedRowKeys: string[];
  onExpandedRowKeysChange: (keys: string[]) => void;
};

function RdoPeriodoSection({
  section,
  filtersKey,
  expandedRowKeys,
  onExpandedRowKeysChange,
}: Props) {
  const iconVisual = getRdoOcupacaoIconVisual(section.ocupacao);

  return (
    <Section>
      <Head>
        <IconBadge
          aria-hidden
          $background={iconVisual.background}
          $border={iconVisual.border}
        >
          {iconVisual.icon}
        </IconBadge>
        <Title>{section.titulo}</Title>
      </Head>
      <RdoOperacoesTable
        rows={section.rows}
        ocupacao={section.ocupacao}
        periodo={section.titulo}
        safraPeriodoId={section.safraPeriodoId}
        filtersKey={filtersKey}
        expandedRowKeys={expandedRowKeys}
        onExpandedRowKeysChange={onExpandedRowKeysChange}
      />
    </Section>
  );
}

export default RdoPeriodoSection;

const Section = styled.section`
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
  padding: 12px;

  & + & {
    border-top: 1px solid ${gray300};
  }
`;

const Head = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
`;

const IconBadge = styled.div<{ $background: string; $border: string }>`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: ${({ $background }) => $background};
  border: 1px solid ${({ $border }) => $border};
  display: grid;
  place-items: center;
  flex-shrink: 0;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.55);
`;

const Title = styled.h3`
  margin: 0;
  font-size: 0.95rem;
  font-weight: 800;
  color: ${gray900};
  text-transform: uppercase;
  letter-spacing: 0.02em;
`;
